<template>
  <div class="tab-buttons">
    <button
      v-for="(item, index) in items"
      :key="item"
      class="tab-button shadow text-uppercase"
      :class="{ active: index === value }"
      @click="onClick(index)"
    >
      {{ item }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'TabButtons',
  components: {},
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    onClick(index) {
      this.$emit('input', index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables';

.tab-button {
  background-color: $greyLight;
  padding: $spacer_small $spacer_mid;
  border: 0;
  border-radius: 25px;
  line-height: 1;
  color: $greyDark;
  min-width: 170px;
  transition: all ease-in-out 0.25s;
  &:focus {
    outline: none;
  }
}

@media only screen and (max-width: 450px) {
  .tab-button:first-child {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom: 0;
  }
  .tab-button:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top: 0;
  }
}
.tab-button:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
}
.tab-button:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}
.active {
  font-weight: 600;
  background-color: white;
  color: $primary;
}
</style>
